import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'

import { config } from './config'
import {
  Wrapper,
  Title,
  ContainerImage,
  HexagonWrapper,
  ContentWrapper,
  ContainerInfo,
} from './styled'

export function Redirect() {
  return (
    <Wrapper {...config.wrapperSection}>
      <ContentWrapper>
        <ContainerInfo>
          <Title as="h1" className="header-title">
            {config.titleSection.title}
          </Title>
          <HexagonWrapper>
            <ImageWithPlaceholder {...config.imageHexagon} alt="redirect" />
          </HexagonWrapper>
        </ContainerInfo>
        <ContainerImage {...config.imageSection} className="header-image">
          <ImageWithPlaceholder
            {...config.imageSection}
            alt={config.imageSection.alt}
          />
        </ContainerImage>
      </ContentWrapper>
    </Wrapper>
  )
}
